/* ===================================================================

    Author          : Valid Theme
    Template Name   : Healdi - Medical & Health Template
    Version         : 1.0

* ================================================================= */

(function($) {
    "use strict";

    $(document).on('ready', function() {


        /* ==================================================
            # Wow Init
         ===============================================*/
        var wow = new WOW({
            boxClass: 'wow', // animated element css class (default is wow)
            animateClass: 'animated', // animation css class (default is animated)
            offset: 0, // distance to the element when triggering the animation (default is 0)
            mobile: true, // trigger animations on mobile devices (default is true)
            live: true // act on asynchronously loaded content (default is true)
        });
        wow.init();


        /* ==================================================
            # Tooltip Init
        ===============================================*/
        $('[data-toggle="tooltip"]').tooltip();



        /* ==================================================
            # Smooth Scroll
         ===============================================*/
        $("body").scrollspy({
            target: ".navbar-collapse",
            offset: 200
        });
        $('a.smooth-menu').on('click', function(event) {
            var $anchor = $(this);
            var headerH = '75';
            $('html, body').stop().animate({
                scrollTop: $($anchor.attr('href')).offset().top - headerH + "px"
            }, 1500, 'easeInOutExpo');
            event.preventDefault();
        });


        /* ==================================================
            # Banner Animation
        ===============================================*/
        function doAnimations(elems) {
            //Cache the animationend event in a variable
            let animEndEv = 'webkitAnimationEnd animationend';
            elems.each(function() {
                let $this = $(this),
                    $animationType = $this.data('animation');
                $this.addClass($animationType).one(animEndEv, function() {
                    $this.removeClass($animationType);
                });
            });
        }

        //Variables on page load
        let $immortalCarousel = $('.animate_text');

        //Initialize carousel
        $immortalCarousel.carousel();

        //Animate captions in first slide on page load
        let $firstAnimatingElems = $immortalCarousel.find('.item:first').find("[data-animation ^= 'animated']");
        doAnimations($firstAnimatingElems);

        //Other slides to be animated on carousel slide event
        $immortalCarousel.on('slide.bs.carousel', function(e) {
            doAnimations($(e.relatedTarget).find("[data-animation ^= 'animated']"));
        });

        /* ==================================================
            # imagesLoaded active
        ===============================================*/
        $('#portfolio-grid,.blog-masonry').imagesLoaded(function() {

            /* Filter menu */
            $('.mix-item-menu').on('click', 'button', function() {
                var filterValue = $(this).attr('data-filter');
                $grid.isotope({
                    filter: filterValue
                });
            });

            /* filter menu active class  */
            $('.mix-item-menu button').on('click', function(event) {
                $(this).siblings('.active').removeClass('active');
                $(this).addClass('active');
                event.preventDefault();
            });

            /* Filter active */
            var $grid = $('#portfolio-grid').isotope({
                itemSelector: '.pf-item',
                percentPosition: true,
                masonry: {
                    columnWidth: '.pf-item',
                }
            });

            /* Filter active */
            $('.blog-masonry').isotope({
                itemSelector: '.blog-item',
                percentPosition: true,
                masonry: {
                    columnWidth: '.blog-item',
                }
            });

        });


        /* ==================================================
           # Fun Factor Init
       ===============================================*/
        $('.timer').countTo();
        $('.fun-fact').appear(function() {
            $('.timer').countTo();
        }, {
            accY: -100
        });


        /* ==================================================
            # Magnific popup init
         ===============================================*/
        $(".popup-link").magnificPopup({
            type: 'image',
            callbacks: {
                beforeOpen: function() {
                    jQuery('body').css('overflow', 'hidden');
                },
                beforeClose: function() {
                    jQuery('body').css('overflow', 'auto');
                }
            }
        });

        $(".popup-gallery").magnificPopup({
            type: 'image',
            gallery: {
                enabled: true
            },
            callbacks: {
                beforeOpen: function() {
                    jQuery('body').css('overflow', 'hidden');
                },
                beforeClose: function() {
                    jQuery('body').css('overflow', 'auto');
                }
            }
        });

        $(".popup-youtube, .popup-video, .popup-gmaps").magnificPopup({
            type: "iframe",
            mainClass: "mfp-fade",
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false,
            callbacks: {
                beforeOpen: function() {
                    jQuery('body').css('overflow', 'hidden');
                },
                beforeClose: function() {
                    jQuery('body').css('overflow', 'auto');
                }
            }
        });

        $('.magnific-mix-gallery').each(function() {
            var $container = $(this);
            var $imageLinks = $container.find('.item');

            var items = [];
            $imageLinks.each(function() {
                var $item = $(this);
                var type = 'image';
                if ($item.hasClass('magnific-iframe')) {
                    type = 'iframe';
                }
                var magItem = {
                    src: $item.attr('href'),
                    type: type
                };
                magItem.title = $item.data('title');
                items.push(magItem);
            });

            $imageLinks.magnificPopup({
                mainClass: 'mfp-fade',
                items: items,
                gallery: {
                    enabled: true,
                    tPrev: $(this).data('prev-text'),
                    tNext: $(this).data('next-text')
                },
                type: 'image',
                callbacks: {
                    beforeOpen: function() {
                        jQuery('body').css('overflow', 'hidden');

                        var index = $imageLinks.index(this.st.el);
                        if (-1 !== index) {
                            this.goTo(index);
                        }
                    },
                    beforeClose: function() {
                        jQuery('body').css('overflow', 'auto');
                    }
                }
            });
        });

        $('.instagram-carousel').each(function () {
            $(this).find('.single-instagram-post')
                .on('auxclick click', function (e) {
                    e.preventDefault();
                })
                .on('middleclick', function (e) {
                    window.open($(this).attr('data-permalink'));
                });

            $(this).magnificPopup({
                type: 'image',
                delegate: 'a',
                mainClass: 'mfp-fade',
                gallery: {
                    enabled: true,
                    navigateByImgClick: false,
                },
                removalDelay: 300,
                preloader: false,
                preload: [0, 0],
                fixedContentPos: false,
                callbacks: {
                    buildControls: function() {

                        let dots = $("<div class='mfp-dots'></div>");

                        let popup = this;

                        popup._checkIfClose = function(target) {

                            if($(target).hasClass('mfp-prevent-close')) {
                                return;
                            }

                            let closeOnContent = popup.st.closeOnContentClick;
                            let closeOnBg = popup.st.closeOnBgClick;

                            if(closeOnContent && closeOnBg) {
                                return true;
                            } else {

                                // We don't close the popup if click is on navigation dots
                                if($(target).hasClass('mfp-dots') || $(target).hasClass('mfp-dot')) {
                                    return false;
                                }

                                // We close the popup if click is on close button or on preloader. Or if there is no content.
                                if(!popup.content || $(target).hasClass('mfp-close') || (popup.preloader && target === popup.preloader[0]) ) {
                                    return true;
                                }

                                // if click is outside the content
                                if(  (target !== popup.content[0] && !$.contains(popup.content[0], target))  ) {
                                    if(closeOnBg) {
                                        // last check, if the clicked element is in DOM, (in case it's removed onclick)
                                        if( $.contains(document, target) ) {
                                            return true;
                                        }
                                    }
                                } else if(closeOnContent) {
                                    return true;
                                }

                            }
                            return false;
                        };

                        let children = Object.values(popup.st.items).slice(0, popup.st.items.length);

                        children.forEach((item, index)  => {
                            dots.append("<button type='button' class='mfp-dot' aria-label='post "+index+"' data-index='"+index+"'></button>");
                        });

                        popup.contentContainer.append(dots);
                    },
                    open: function () {
                        $('body').addClass('mfp-opened mfp-carousel-opened');
                    },
                    close: function () {
                        $('body').removeClass('mfp-opened mfp-carousel-opened');
                    },
                    imageLoadComplete: function () {
                        let popup = this;
                        let currItem = popup.currItem;

                        $(currItem.img).on('click middleclick', function () {
                            window.open(currItem.el.attr('data-permalink'));
                        });

                        popup.contentContainer.append(popup.arrowLeft.add(popup.arrowRight));

                        popup.contentContainer.find(".mfp-dots .mfp-dot").removeClass('mfp-dot-active');
                        popup.contentContainer.find(".mfp-dots .mfp-dot[data-index="+currItem.index+"]").addClass('mfp-dot-active');

                        popup.contentContainer.find(".mfp-dots .mfp-dot").on('click', function () {
                            popup.goTo(Number($(this).attr('data-index')));
                            popup.updateItemHTML();
                        });
                    }
                }
            })
        });


        /* ==================================================
            # Doctor Carousel
         ===============================================*/
        $('.doctors-carousel').owlCarousel({
            loop: false,
            nav: false,
            margin:30,
            dots: true,
            autoplay: true,
            items: 1,
            navText: [
                "<i class='fa fa-angle-left'></i>",
                "<i class='fa fa-angle-right'></i>"
            ]
        });


        /* ==================================================
            # Tips Carousel
         ===============================================*/
        $('.tips-carousel').owlCarousel({
            loop: false,
            nav: false,
            margin:30,
            dots: true,
            autoplay: true,
            items: 1,
            navText: [
                "<i class='fa fa-angle-left'></i>",
                "<i class='fa fa-angle-right'></i>"
            ]
        });


        /* ==================================================
            # Department Carousel
         ===============================================*/
        $('.department-carousel').owlCarousel({
            margin: 30,
            nav: false,
            navText: [
                "<i class='fa fa-angle-left'></i>",
                "<i class='fa fa-angle-right'></i>"
            ],
            dots: true,
            autoplayHoverPause: true,
            responsive: {
                0: {
                    items: 1
                },
                992: {
                    items: 2
                },
                1200: {
                    items: 3
                }
            }
        });


        /* ==================================================
            # Instagram Slider
         ===============================================*/
        $('.instagram-slider').each(function () {
            let $slider = $(this);
            let slideCount = $slider.children().length;

            $slider.owlCarousel({
                margin: $slider.data('gutters') === false || $slider.data('gutters') === 'false' ? 0 : 15,
                nav: true,
                navText: [
                    "<svg width='56' height='56' viewBox='7 4 10 16' fill='none' stroke='currentColor' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'><polyline points='15 18 9 12 15 6'></polyline></svg>",
                    "<svg width='56' height='56' viewBox='7 4 10 16' fill='none' stroke='currentColor' stroke-width='1.75' stroke-linecap='round' stroke-linejoin='round'><polyline points='9 18 15 12 9 6'></polyline></svg>"
                ],
                dots: true,
                loop: false,
                autoplay: false,
                autoplayHoverPause: true,
                responsive: {
                    0: {
                        items: 2,
                        loop: slideCount > 2,
                        autoplay: slideCount > 2
                    },
                    576: {
                        items: 3,
                        loop: slideCount > 3,
                        autoplay: slideCount > 3
                    },
                    992: {
                        items: 4,
                        loop: slideCount > 4,
                        autoplay: slideCount > 4
                    }
                }
            });
        });


        /* ==================================================
            # Testimonials Carousel
         ===============================================*/
        $('.testimonials-carousel').owlCarousel({
            loop: true,
            nav: false,
            margin:30,
            dots: true,
            autoplay: false,
            items: 1,
            navText: [
                "<i class='fa fa-angle-left'></i>",
                "<i class='fa fa-angle-right'></i>"
            ],
            responsive: {
                1000: {
                    stagePadding: 100,
                    items: 2,
                }
            }
        });


        /* ==================================================
            Preloader Init
         ===============================================*/
        $(window).on('load', function() {
            // Animate loader off screen
            $(".se-pre-con").fadeOut("slow");
        });


        /* ==================================================
            Nice Select Init
         ===============================================*/
        $('select').niceSelect();

        /* ==================================================
            Team specializations
         ===============================================*/
        $('.item-specializations-toggle').each(function () {
            let $id = $(this).attr('data-id');

            if($id.length) {
                $(this).on('click', function () {

                    $('#'+$id).toggleClass('shown');
                })
            }
        })

        $('.item-specializations-close').each(function () {
            let $id = $(this).attr('data-id');

            if($id.length) {
                $(this).on('click', function () {

                    $('#'+$id).removeClass('shown');
                })
            }
        })


        /* ==================================================
            Contact widget docked state

            The widget is position:sticky, so it's pinned to the
            bottom of the viewport (floating over whatever content
            is scrolled underneath) most of the time. Only once it
            reaches its natural resting position at the end of the
            page (no longer overlapping anything) should it pick up
            the background color of the section before it. A sentinel
            placed right after the widget becomes visible exactly when
            that happens.
        ===============================================*/
        let contactWidget = document.querySelector('.contact-widget');
        let contactWidgetSentinel = document.querySelector('.contact-widget-sentinel');

        if (contactWidget && contactWidgetSentinel && 'IntersectionObserver' in window) {
            let observer = new IntersectionObserver(function (entries) {
                contactWidget.classList.toggle('docked', entries[0].isIntersecting);
            });

            observer.observe(contactWidgetSentinel);
        }


    }); // end document ready function
})(jQuery); // End jQuery
